export const USE_CRM_IMPORT_MOCK = process.env.REACT_APP_CRM_IMPORT_MOCK === "true";
